import "core-js/modules/es.array.map.js";
import React from 'react';
import { Close } from '@material-ui/icons';
import { Grid, IconButton, Typography, Box } from "../..";
export function Single(_ref) {
  var sections = _ref.sections,
    bottomComponent = _ref.bottomComponent,
    title = _ref.title,
    onClose = _ref.onClose,
    onPublishEvent = _ref.onPublishEvent;
  var Markup = sections.map(function (_ref2) {
    var label = _ref2.label,
      component = _ref2.component,
      action = _ref2.action;
    var headingLabel = label.toUpperCase();
    return /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      key: "".concat(label, " section"),
      flexDirection: "column",
      justifyContent: "center",
      mb: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "section"
    }, headingLabel)), action && /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, action)), /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, component));
  });
  return /*#__PURE__*/React.createElement(Box, {
    p: 5
  }, /*#__PURE__*/React.createElement(Box, {
    pb: 5
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "h5"
  }, title)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 1
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": "close drawer",
    onClick: function onClick() {
      onPublishEvent();
      onClose();
    }
  }, /*#__PURE__*/React.createElement(Close, null)))))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column"
  }, Markup), bottomComponent && /*#__PURE__*/React.createElement(Box, {
    mt: 5
  }, bottomComponent));
}